import store from '@/store'
import { getIbtRegisterRedirectPath } from '@/util/register/getIbtRedirectPath'

export const RegisterRoutePath = Object.freeze({
  register: '/register',
  registerWelcome: '/register/welcome',
  openAccount: '/register/openAccount',
  identityVerification: '/register/identityVerification',
  identityVerificationComplete: '/register/identityVerification/complete',
  poaVerification: '/register/poaVerification',
  poaVerificationComplete: '/register/poaVerification/complete',
  ibtRegister: '/ibtRegister',
  ibtVerification: '/ibtRegister/ibtVerification',
})

export default [
  {
    path: RegisterRoutePath.register,
    name: 'register',
    component: () => import('@/views/register/Register.vue'),
    meta: {
      restrictBanner: true,
    },
  },
  {
    path: RegisterRoutePath.openAccount,
    name: 'openAccount',
    component: () => import('@/views/register/openAccount/OpenAccount.vue'),
    meta: {
      restrictBanner: true,
    },
    beforeEnter: async (to, from, next) => {
      // Only for apiTo_login_register
      if (to.path === RegisterRoutePath.registerWelcome) {
        if (store.state.register.isRegisterPath) {
          store.dispatch('register/setIsRegisterPath', false)
          next()
        } else {
          next(RegisterRoutePath.openAccount)
        }
      } else {
        next()
      }
    },
    alias: [RegisterRoutePath.registerWelcome],
  },
  {
    path: RegisterRoutePath.identityVerification,
    name: 'identityVerification',
    component: () => import('@/views/register/poiVerification/PoiVerification.vue'),
    meta: {
      restrictBanner: true,
    },
    alias: [RegisterRoutePath.identityVerificationComplete],
  },
  {
    path: RegisterRoutePath.poaVerification,
    name: 'poaVerification',
    component: () => import('@/views/register/poaVerification/PoaVerification.vue'),
    meta: {
      restrictBanner: true,
    },
    alias: [RegisterRoutePath.poaVerificationComplete],
  },
  {
    path: RegisterRoutePath.ibtRegister,
    name: 'ibtRegister',
    component: () => import('@/views/register/ibtVerification/BankWireTransfer.vue'),
    meta: {
      restrictBanner: true,
      authority: true,
    },
    beforeEnter: async (to, from, next) => {
      const redirectPath = await getIbtRegisterRedirectPath()
      if (redirectPath?.length > 0) {
        next(redirectPath)
      } else {
        next()
      }
    },
  },
  {
    path: RegisterRoutePath.ibtVerification,
    name: 'ibtVerification',
    component: () => import('@/views/register/ibtVerification/IbtVerification.vue'),
    meta: {
      restrictBanner: true,
      authority: true,
    },
    beforeEnter: async (to, from, next) => {
      const redirectPath = await getIbtRegisterRedirectPath()

      if (redirectPath?.length > 0) {
        next(redirectPath)
      } else {
        next()
      }
    },
  },
]
